export enum Framework {
    React = "react",
    Vanilla = "vanilla",
}
